export default __webpack_public_path__ + "static/in-front-of-clinic-dc214d19a59a4533bb70da9f3acfea0e.jpg";